import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var generatePaySlipRes;
export const generatePaySlipTodo = createAsyncThunk('generatePaySlip', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'hr/download_pay_slip',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token,
                "ibusiness_area_id": user_id.ibusiness_area_id,
                "vfin_year_name": data?.year,
                "month": data?.month,
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return generatePaySlipRes = res.data
    } catch (error) {
        return generatePaySlipRes = error.response.data
    }
})